var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSongsSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.09998 12C1.09998 5.9801 5.98007 1.1 12 1.1C18.0199 1.1 22.9 5.9801 22.9 12C22.9 18.0199 18.0199 22.9 12 22.9C5.98007 22.9 1.09998 18.0199 1.09998 12ZM12 10C10.8954 10 9.99998 10.8955 9.99998 12C9.99998 13.1045 10.8954 14 12 14C13.1045 14 14 13.1045 14 12C14 10.8955 13.1045 10 12 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSongsSolid);
export default __webpack_public_path__ + "static/media/songs-solid.7da6d679c600c3b72536f6226e1b7b82.svg";
export { ForwardRef as ReactComponent };